// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plano de fundo com gradiente utilizando as cores do logo */
.Login_pageContainer__YNYQp {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(135deg, #074273 0%, #00a0e4 100%);
    position: relative;
    overflow: hidden;
}

/* Caixa de login com design moderno */
.Login_loginBox__jvKwN {
    background-color: #fff;
    padding: 40px;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    text-align: center;
    position: relative;
    z-index: 2;
    max-width: 350px;
    width: 100%;
}

/* Logo centralizada */
.Login_logoContainer__415a- {
    margin-bottom: 20px;
}

.Login_loginLogo__QfgJf {
    width: 100px;
}

/* Título estilizado com cor do logo */
.Login_title__PUwhE {
    font-size: 24px;
    color: #074273;
    /* Azul escuro do logo */
    margin-bottom: 10px;
    font-weight: bold;
}

.Login_subtitle__ZgxQV {
    font-size: 14px;
    color: #666;
    margin-bottom: 30px;
}

/* Input moderno com animação de foco */
.Login_loginInput__CodeW {
    width: 100%;
    padding: 12px;
    margin: 10px 0;
    border-radius: 30px;
    border: 1px solid #e0e0e0;
    background: #f9f9f9;
    font-size: 14px;
    transition: all 0.3s ease;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.1);
}

.Login_loginInput__CodeW:focus {
    border-color: #00a0e4;
    /* Azul claro do logo */
    box-shadow: 0 0 8px rgba(0, 160, 228, 0.4);
    background: #fff;
}

/* Botão de login estilizado */
.Login_loginButton__BKQ3F {
    padding: 12px 25px;
    border: none;
    border-radius: 30px;
    background-color: #f59c11;
    /* Laranja do logo */
    color: white;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s ease;
}

.Login_loginButton__BKQ3F:hover {
    background-color: #e6392f;
    /* Vermelho do logo */
}

/* Mensagem de erro */
.Login_error__\\+MNK9 {
    color: #e6392f;
    /* Vermelho do logo */
    margin-top: 10px;
}

/* Elementos decorativos */
.Login_decorativeCircle__Ed7ox {
    position: absolute;
    width: 400px;
    height: 400px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    top: -50px;
    right: -150px;
    z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/LIFTrac/Login/Login.module.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,UAAU;AACd","sourcesContent":["/* Plano de fundo com gradiente utilizando as cores do logo */\r\n.pageContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    background: linear-gradient(135deg, #074273 0%, #00a0e4 100%);\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Caixa de login com design moderno */\r\n.loginBox {\r\n    background-color: #fff;\r\n    padding: 40px;\r\n    border-radius: 15px;\r\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 2;\r\n    max-width: 350px;\r\n    width: 100%;\r\n}\r\n\r\n/* Logo centralizada */\r\n.logoContainer {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.loginLogo {\r\n    width: 100px;\r\n}\r\n\r\n/* Título estilizado com cor do logo */\r\n.title {\r\n    font-size: 24px;\r\n    color: #074273;\r\n    /* Azul escuro do logo */\r\n    margin-bottom: 10px;\r\n    font-weight: bold;\r\n}\r\n\r\n.subtitle {\r\n    font-size: 14px;\r\n    color: #666;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n/* Input moderno com animação de foco */\r\n.loginInput {\r\n    width: 100%;\r\n    padding: 12px;\r\n    margin: 10px 0;\r\n    border-radius: 30px;\r\n    border: 1px solid #e0e0e0;\r\n    background: #f9f9f9;\r\n    font-size: 14px;\r\n    transition: all 0.3s ease;\r\n    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.loginInput:focus {\r\n    border-color: #00a0e4;\r\n    /* Azul claro do logo */\r\n    box-shadow: 0 0 8px rgba(0, 160, 228, 0.4);\r\n    background: #fff;\r\n}\r\n\r\n/* Botão de login estilizado */\r\n.loginButton {\r\n    padding: 12px 25px;\r\n    border: none;\r\n    border-radius: 30px;\r\n    background-color: #f59c11;\r\n    /* Laranja do logo */\r\n    color: white;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.loginButton:hover {\r\n    background-color: #e6392f;\r\n    /* Vermelho do logo */\r\n}\r\n\r\n/* Mensagem de erro */\r\n.error {\r\n    color: #e6392f;\r\n    /* Vermelho do logo */\r\n    margin-top: 10px;\r\n}\r\n\r\n/* Elementos decorativos */\r\n.decorativeCircle {\r\n    position: absolute;\r\n    width: 400px;\r\n    height: 400px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border-radius: 50%;\r\n    top: -50px;\r\n    right: -150px;\r\n    z-index: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Login_pageContainer__YNYQp`,
	"loginBox": `Login_loginBox__jvKwN`,
	"logoContainer": `Login_logoContainer__415a-`,
	"loginLogo": `Login_loginLogo__QfgJf`,
	"title": `Login_title__PUwhE`,
	"subtitle": `Login_subtitle__ZgxQV`,
	"loginInput": `Login_loginInput__CodeW`,
	"loginButton": `Login_loginButton__BKQ3F`,
	"error": `Login_error__+MNK9`,
	"decorativeCircle": `Login_decorativeCircle__Ed7ox`
};
export default ___CSS_LOADER_EXPORT___;
